import axios from "axios";

export const rawAxiosApi = (url, method, data, headers) => {
  return axios.create()({
    method: method.toLowerCase(),
    url,
    data,
    headers,
  });
};
